module.exports = __webpack_public_path__ + "img/doodlebob.706f0362.jpg";